import AdivareSignaturePad from './adivare-signature-pad';
import signatureConfig from './signature.config';

export function fromCanvas(canvas) {
  return new AdivareSignaturePad(signatureConfig, canvas);
}

export function newObject() {
  const canvas = document.createElement('canvas');
  canvas.height = signatureConfig.height;
  canvas.width = signatureConfig.width;
  return new AdivareSignaturePad(signatureConfig, canvas);
}

export const MODE_HAND_DRAWN = 'hand_drawn';
export const MODE_FROM_NAME = 'from_name';
